import Vue from 'vue'
import Vuex from 'vuex'
import doctorpage from './modules/doctorpage'
import seek from './modules/seek'
import beautyitem from './modules/beautyitem'
import rongtoken from './modules/rongtoken'
  Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    doctorpage,
    seek,
    beautyitem,
    rongtoken
  }
})




// WEBPACK FOOTER //
// ./src/vuex/store.js